import { SERVER_URL } from "../constants/constants.js";
import { customFetch } from "../components/common/fetchWrapper";

export const dl_insuranceService = {
  getList,
  assignDealNumber,
  assignIdentityToJacket
};

async function getList(org_id) {
  const url = SERVER_URL + "/org/" + org_id + "/dealjacket/identity";

  const list = await customFetch("GET", url, null, null);
  return list;
}

async function assignDealNumber(org_id, deal_jacket_id, deal_number) {
  const url =
    SERVER_URL + "/org/" + org_id + "/dealjacket/identity/" + deal_jacket_id;

  let request = {
    deal_number: deal_number,
  };
  const result = await customFetch("PATCH", url, null, JSON.stringify(request));
  return result;
}

async function assignIdentityToJacket(target_deal_jacket_id, identity_jacket) {
  const url =
    SERVER_URL + "/dealjacket/" + target_deal_jacket_id + "/identity";

  let request = {
    deal_jacket_id: identity_jacket.deal_jacket_id,
    customer_name: identity_jacket.customer_name,
  };
  const result = await customFetch("PUT", url, null, JSON.stringify(request));
  return result;
}
